import { render } from "./ViewsDelegate.vue?vue&type=template&id=640c8531"
import script from "./ViewsDelegate.vue?vue&type=script&lang=js"
export * from "./ViewsDelegate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__